module.exports = __webpack_public_path__ + "static/setteVulcani-4a6481b2c426ad85b65d5adfed4d0264.jpeg";